export default class VideoPlayer {
  constructor() {
    this.$videoPlayers = document.querySelectorAll('.video-player');

    if (!this.$videoPlayers) {
      return;
    }

    this.init();
  }

  init() {
    this.eventTriggerCover();
  }

  appendVideoAndPlay($container) {
    const id = $container.getAttribute('data-id');
    const $iframe = document.createElement('iframe');

    let src = '',
      newId = '';
    // if user provided full link
    if (id.includes('http://') || id.includes('https://')) {
      if (id.includes('watch?')) {
        // if youtube link contains "watch" type link
        const url = new URL(id);
        newId = url.searchParams.get('v');
        src = `https://www.youtube.com/embed/${newId}?autoplay=true`;
      } else {
        // if youtube link has different format, eg. with "embed"
        newId = id.split('/');
        newId = newId[newId.length - 1];
        newId = newId.split('?')[0];
        src = `https://www.youtube.com/embed/${newId}?autoplay=true`;
      }
    } else {
      // if user provided id of the video
      src = `https://www.youtube.com/embed/${id}?autoplay=true`;
    }

    const iframeAttr = {
      allowfullscreen: 'true',
      allow:
        'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture',
      frameborder: '0',
      src: src,
    };

    Object.keys(iframeAttr).forEach((key) =>
      $iframe.setAttribute(key, iframeAttr[key])
    );

    $container.classList.add('video-player--hidden');
    $container.append($iframe);
  }

  eventTriggerCover() {
    this.$videoPlayers.forEach(($player) => {
      $player.addEventListener('click', () => this.appendVideoAndPlay($player));
    });
  }
}



// WEBPACK FOOTER //
// ./front/treasurybond/js/components/video-player/VideoPlayer.js